import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "事件追踪", to: "/events" },
  { label: "辟谣专区", to: "/mythbusting" },
  { label: "关于我们", to: "/about" },
  { label: "联系与纠错", to: "/contact" },
];

const principlesLinks = [
  { label: "只挂原文与出处", to: "/about" },
  { label: "时间顺序还原", to: "/about" },
  { label: "区分结论与进展", to: "/about" },
  { label: "持续更新不删帖", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-8 lg:grid-cols-4 lg:gap-10 lg:py-16">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-radar-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              {siteInfo.name}
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-secondary-200">{siteInfo.intro}</p>
          <a
            href={`mailto:${siteInfo.email}`}
            rel="nofollow"
            className="mt-4 inline-flex items-center gap-2 text-sm text-background-50 hover:text-accent-300"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-mail-line"></i>
            </span>
            {siteInfo.email}
          </a>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold text-background-50">网站导航</h4>
          <ul className="flex flex-col gap-2.5">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-sm text-secondary-200 hover:text-accent-300">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold text-background-50">内容原则</h4>
          <ul className="flex flex-col gap-2.5">
            {principlesLinks.map((link) => (
              <li key={link.label}>
                <Link to={link.to} className="text-sm text-secondary-200 hover:text-accent-300">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold text-background-50">更新说明</h4>
          <p className="text-sm leading-relaxed text-secondary-200">
            内容以官方公开发布信息为准，暂未发声的事件会单独标注。所有时间线均在页面标注最近核对时间。
          </p>
          <p className="mt-4 text-sm text-secondary-200">{siteInfo.period}</p>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-secondary-300 sm:flex-row md:px-8">
          <span>© 2026 {siteInfo.name} · 内容整理与官方原文索引</span>
          <span className="flex flex-wrap items-center justify-center gap-3">
            <Link to="/about" className="hover:text-accent-300">
              关于我们
            </Link>
            <Link to="/contact" className="hover:text-accent-300">
              联系与纠错
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}